import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, submit } from 'redux-form'

import CreateOrEditGroupBasicsPage from '../CreateOrEditGroupBasics'

let _createGroupOptions
export const createGroupOptions = (v?: any) => {
  if (v) {
    _createGroupOptions = v
  }
  return _createGroupOptions
}

const mapStateToProps = ({
  location: { payload: { parent, privacy = 'PUBLIC' } }
}) => {
  return {
    initialValues: {
      privacy: privacy,
      min_privacy: privacy,
      parent
    }
  }
}

const mapDispatchToProps = dispatch => ({
  remoteSubmit: () => dispatch(submit('create-group')),
  onSubmit: () => {
    dispatch({
      type: 'groups/_create/privacy',
      meta: {
        location: {
          kind: 'redirect'
        }
      }
    })
  },
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'create-group',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(CreateOrEditGroupBasicsPage)
)
